import { CREDENTIALS } from '../../constants';

/** Reads the signed-in session (location, JWT, staff hint) from localStorage for catering sagas. */
export function getCredentials(): { locationId: string; token: string | null; staffId?: string } {
  try {
    const raw = localStorage.getItem(CREDENTIALS);
    if (!raw) return { locationId: '', token: null };
    const stored = JSON.parse(raw);
    const cred = stored?.credentials ?? stored;
    // The JWT's userId doesn't always map cleanly to a staff record, so this is sent
    // as an optional hint the backend can use to attribute notifications (sentBy) to
    // the staff member who actually triggered them — falls back cleanly when absent.
    const staffId = String(cred?.id ?? cred?.userId ?? cred?.staff_id ?? cred?.authUserId ?? '').trim() || undefined;
    return {
      locationId: String(cred?.locationId ?? cred?.location_id ?? ''),
      token: cred?.accessToken ?? cred?.access_token ?? null,
      staffId,
    };
  } catch {
    return { locationId: '', token: null };
  }
}
